export default {
      id: "ic-plan-dechets-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-dechets-usage",
      toString: function () {
        return this.url;
      }
    }